var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#5E5E5E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Event variations"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -323.5,
    y: -368.5,
    width: 367,
    height: 1160,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Going",
    filter: "url(#filter0_b_10_61)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-304 -4C-304 -8.41827 -300.418 -12 -296 -12H16C20.4183 -12 24 -8.41828 24 -4V109C24 113.418 20.4183 117 16 117H-296C-300.418 117 -304 113.418 -304 109V-4Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Indicator"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z",
    fill: "#7EFF8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.29 7.78981C5.19 7.78981 5.095 7.7498 5.025 7.67981L3.61 6.2648C3.465 6.1198 3.465 5.8798 3.61 5.7348C3.755 5.5898 3.995 5.5898 4.14 5.7348L5.29 6.88481L7.86 4.3148C8.005 4.1698 8.245 4.1698 8.39 4.3148C8.535 4.4598 8.535 4.6998 8.39 4.8448L5.555 7.67981C5.485 7.7498 5.39 7.78981 5.29 7.78981Z",
    fill: "black"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_10_61",
    x: -364,
    y: -72,
    width: 448,
    height: 249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10_61"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10_61",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-304 -4C-304 -8.41827 -300.418 -12 -296 -12H16C20.4183 -12 24 -8.41828 24 -4V109C24 113.418 20.4183 117 16 117H-296C-300.418 117 -304 113.418 -304 109V-4Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.22f5b713608d03857e986b9f33e436a9.svg";
export { ForwardRef as ReactComponent };